/**
 * @fileoverview 繁體中文語言包
 * @description 網站所有繁體中文文案的集中管理
 */

const zh = {
  // 通用
  common: {
    appName: 'AugurX',
    appSlogan: '專業大宗商品預測市場',
    loading: '載入中...',
    error: '發生錯誤',
    retry: '重試',
    confirm: '確認',
    cancel: '取消',
    submit: '提交',
    save: '儲存',
    edit: '編輯',
    delete: '刪除',
    back: '返回',
    more: '更多',
    all: '全部',
    search: '搜尋',
    filter: '篩選',
    sort: '排序',
    yes: '是',
    no: '否',
    amount: '金額',
    price: '價格',
    volume: '交易量',
    time: '時間',
    status: '狀態',
    action: '操作',
    comingSoon: '功能即將上線',
    connectWallet: '連接錢包',
    copySuccess: '複製成功',
    noData: '暫無資料',
    refresh: '重新整理',
    loadMore: '載入更多',
    login: '登入',
    processing: '處理中...',
    submitting: '提交中...',
    close: '關閉',
    viewAll: '查看全部',
    participants: '參與者',
    ended: '已截止',
    daysLater: '{{d}}天後',
    hoursLater: '{{h}}小時後',
    minutesLater: '{{m}}分鐘後',
    daysAgo: '{{d}}天前',
    hoursAgo: '{{h}}小時前',
    minutesAgo: '{{m}}分鐘前',
    justNow: '即將',
    live: '即時',
    hot: '熱門',
    new: '新上',
    enterAfter: '進入',
    marketsCount: '{{n}} 個市場',
    foundMarkets: '找到 {{n}} 個市場',
    adjustFilter: '嘗試調整篩選條件或搜尋關鍵字',
    filterAndSort: '篩選與排序',
    recentlyViewed: '最近瀏覽',
    clearHistory: '清空記錄',
  },

  // 導航
  nav: {
    home: '首頁',
    markets: '市場',
    portfolio: '持倉',
    leaderboard: '排行榜',
    wallet: '錢包',
    loginRequired: '請先登入後查看錢包',
    loginNow: '立即登入',
    depositUsdt: '充值 USDT',
    withdrawUsdt: '提現 USDT',
    depositAmount: '充值金額 (USDT)',
    receivingAddress: '收款地址',
    connectWalletFirst: '請先連接錢包',
    metamaskNotFound: '未偵測到 MetaMask，請安裝 MetaMask 外掛',
    chainConfigFailed: '取得鏈配置失敗',
    waitingSign: '等待 MetaMask 簽名...',
    waitingConfirm: '等待鏈上確認...',
    viewTx: '查看交易',
    depositConfirmed: '充值交易已確認，餘額將在 1-5 分鐘內到帳',
    depositBroadcast: '交易已廣播，充值將在確認後到帳',
    depositConfirmedMsg: '充值交易已確認，餘額將在 1-5 分鐘內到帳',
    depositWarning: '請確保 MetaMask 已切換到 BSC 主網（BNB Smart Chain）。充值 USDT（BEP-20）將直接從您的錢包轉入平台，確認後自動到帳。',
    userRejectedSign: '已取消：使用者拒絕了錢包簽名',
    tonWallet: 'TON 錢包',
    connectTonWallet: '連接 TON 錢包',
    tonDepositWarning: '請使用 TON 錢包發送 USDT Jetton，系統將自動識別並到帳。',
    depositFailed: '充值失敗',
    guidError: '無法獲取用戶 GUID，請重新登錄後再試',
    jettonWalletError: '無法獲取 Jetton Wallet 地址',
    jettonWalletFetchError: '獲取 TON Jetton Wallet 地址失敗，請稍後重試',
    confirmDeposit: '確認充值',
    minDepositError: '最小充值金額為 10 USDT',
    depositMinHint: '最小 {{min}} USDT',
    withdrawAmount: '提現金額',
    available: '可用',
    fee: '手續費',
    actualAmount: '實際到帳',
    confirmWithdraw: '確認提現',
    invalidWithdrawAmount: '請輸入有效的提現金額',
    insufficientBalance: '提現金額不能超過可用餘額',
    withdrawSubmitted: '提現申請已提交，預計 24 小時內到帳',
    withdrawFailed: '提現失敗，錯誤碼：{{code}}',
    withdrawRequestFailed: '提現請求失敗',
    noDeposits: '暫無充值記錄',
    noWithdrawals: '暫無提現記錄',
    statusReviewing: '審核中',
    statusTransfering: '轉帳中',
    statusApproved: '已審核',
    statusCompleted: '已完成',
    statusUnknown: '未知',
    dataRefreshed: '資料已重新整理',
    balanceUpdated: '餘額已更新',
    profile: '個人中心',
    login: '登入',
    register: '註冊',
    logout: '登出',
    telegram: 'Telegram',
    langZh: '繁體中文',
    langEn: 'EN',
    langZhFull: '繁體中文',
    categories: {
      all: '全部市場',
      crypto: '加密貨幣',
      precious_metals: '貴金屬',
      energy: '能源',
      chemicals: '化學品',
      agriculture: '農產品',
    },
  },

  // 首頁
  home: {
    hero: {
      badge: '大宗商品預測市場 · 固定截止結算',
      title: '預判行情，赢在開盤前',
      titleLine1: '預判行情，',
      titleLine2: '赢在開盤前',
      subtitle: '參與大宗商品與加密貨幣價格預測，與全球交易者同台競技',
      cta: '開始預測',
      ctaLeaderboard: '查看排行榜',
      leaderboardCta: '查看排行榜',
      stats: {
        totalVolume: '總交易量',
        activeMarkets: '活躍市場',
        totalUsers: '註冊用戶',
      },
    },
    ticker: {
      label: '即時行情',
    },
    highFreq: {
      badge: '高頻市場',
      title: '5分鐘極速競猜',
      subtitle: '以即時價格為基準，預測5分鐘後漲跌',
      tagline: '每5分鐘自動建立 · 以當前即時價格為基準',
      cta: '立即參與',
      label: '高頻市場',
      basePrice: '基準價格',
      currentPrice: '當前',
      fetching: '取得中...',
      bannerTitle: '5分鐘極速競猜',
      bannerDesc: '即時價格為基準，預測5分鐘後漲跌方向',
      joinNow: '立即參與',
      desc: '每5分鐘自動建立 · 以當前即時價格為基準',
    },
    categoryBanner: {
      commodityTitle: '大宗商品預測市場',
      marketsCount: '個市場',
      enter: '進入',
    },
    sections: {
      hot: '熱門市場',
      new: '新上市場',
      crypto: '加密貨幣',
      commodities: '大宗商品',
      commodity: '大宗商品',
      highFreq: '高頻市場',
      commodityPrediction: '大宗商品預測',
      priceTrend: '價格趨勢預測市場',
      hotEvent: '熱點事件預測市場',
      recentViewed: '最近瀏覽',
      closedMarkets: '休市市場',
    },
    viewAll: '查看全部',
  },

  // 市場大廳頁
  markets: {
    recentViewed: '最近瀏覽',
    clearHistory: '清空記錄',
    subtitle: '參與大宗商品價格預測，固定截止時間，公平競猜',
    activeMarkets: '活躍市場',
    totalMarkets: '總市場',
    filterAndSort: '篩選與排序',
    emptyDesc: '嘗試調整篩選條件或搜尋關鍵字',
    resultCount: '找到 {{n}} 個市場',
  },

  // 市場
  market: {
    long: '做多',
    short: '做空',
    status: {
      active: '進行中',
      resolved: '已結算',
      cancelled: '已取消',
      pending: '待開始',
      ended: '已結束',
      closed: '休市',
    },
    category: {
      all: '全部',
      high_freq: '高頻',
      crypto: '加密貨幣',
      commodity: '大宗商品',
      futures: '期貨',
      forex: '外匯',
      stock: '股票',
      index: '指數',
      event: '事件',
      precious_metals: '貴金屬',
      energy: '能源',
      chemicals: '化學品',
      agriculture: '農產品',
      minerals: '礦產',
    },
    detail: {
      endTime: '截止時間',
      totalVolume: '總交易量',
      liquidity: '流動性',
      participants: '參與人數',
      priceHistory: '價格歷史',
      orderBook: '訂單簿',
      myPosition: '我的持倉',
      rules: '規則說明',
      asset: '資產',
      basePrice: '基準價格（市場建立時）',
      targetPriceLabel: '目標價格',
      currentPrice: '當前即時價格',
      fetching: '取得中...',
      notSet: '未設定',
      highFreqBadge: '高頻市場',
      yesLabel: '是',
      noLabel: '否',
      upLabel: '漲',
      downLabel: '跌',
      longLabel: '做多',
      shortLabel: '做空',
      totalVolumeStat: '總交易量',
      endTimeStat: '截止',
      endsAt: '{{t}}截止',
      opensAt: '下次開市：{{t}}',
      participantsStat: '參與者',
      liveLabel: '即時',
      hotBadge: '熱門',
      rulesTitle: '市場規則說明',
      endTimeLabel: '截止時間：',
      nextOpenTimeLabel: '下次開市：',
      sessionEndTimeLabel: '本輪截止：',
      closedUntil: '市場休市，預計開市：',
      settlementLabel: '結算方式：',
      settlementDesc: '固定截止時間結算，所有參與者共享獎池',
      marketNotFound: '市場不存在或已下線',
      backToMarkets: '返回市場列表',
      currentShort: '當前',
    },
    bet: {
      title: '參與預測',
      buyYes: '買入 是',
      buyNo: '買入 否',
      sellYes: '賣出 是',
      sellNo: '賣出 否',
      amount: '參與金額',
      maxAmount: '最大金額',
      estimatedReturn: '預計回報',
      potentialProfit: '潛在收益',
      confirm: '確認參與',
      balance: '可用餘額',
      minAmount: '最小金額',
      odds: '收益倍率',
      returnRate: '返還率',
      returnRateEst: '預估返還率',
      returnRateTitle: '我的返還率走勢',
      returnRateTitleMarket: '大盤返還率走勢',
      returnRateInfo: '返還率 = 押中後的「利潤」÷ 你的押注額（不含本金）。例如 100% 表示贏了淨賺一個本金（押 100、結算贏可拿回 200）；利潤來自輸方的資金，故對手盤不足時返還率會更低。\n未押注的選項顯示「大盤走勢」（現在入場的預估返還率，隨時間與資金分佈變化）；已押注的選項改用「你自己」的權重（由你入場時間鎖定，越早權重越高），之後只隨他人下注變化——因此每個人不同。',
      returnRateEmpty: '正在採集返還率數據…',
      myPositionTitle: '我的持倉預估',
      posStake: '押注金額',
      yesDirection: 'YES · 是',
      noDirection: 'NO · 否',
      loginToBet: '後即可參與預測',
      suspended: '休市中',
      suspendedDesc: '市場處於交易日曆休市期間，將在開市時自動恢復',
      notStarted: '市場尚未開市',
      notStartedTime: '開市時間：',
      notStartedCountdown: '還有 {{t}}',
      lockWindow: '預測已截止',
      lockWindowDesc: '結算中，等待新一輪開市...',
      successToast: '成功參與 ${{amount}} 到「{{side}}」方向',
      myOrders: '我的預測記錄',
      noOrders: '暫無預測記錄',
      buyYesLabel: '買入是',
      buyNoLabel: '買入否',
      won: '勝',
      lost: '負',
      pending: '待結算',
      loadMoreOrders: '載入更多（還剩 {{n}} 條）',
      roundCountdown: '本輪截止倒計時',
      roundEnded: '本輪已截止，等待新一輪...',
      roundLabel: '第 {{n}} 輪',
      roundResult: '結果：{{side}} 方獲勝',
      roundWon: '勝',
      roundLost: '負',
      roundTie: '平局',
      roundPending: '待結算',
      roundYesTotal: 'YES 總額',
      roundNoTotal: 'NO 總額',
      roundProfit: '收益',
      roundGrossProfit: '總收益',
      roundTax: '平台手續費',
      roundNetProfit: '本輪淨盈虧',
      roundWinProfit: '贏方收益(稅後)',
      roundLossAmount: '輸方損失',
      roundBasePrice: '基準價格',
      roundSettlePrice: '結算價格',
      roundPriceUnsettled: '待結算',
      betAmountTooLow: '押注金額不能低於 {{min}} USDT',
      betAmountTooHigh: '押注金額不能高於 {{max}} USDT',
    },
    betStatus: {
      preparingChain: '餘額不足，正在準備鏈上轉帳...',
      waitingSign: '請在錢包中確認轉帳簽名...',
      waitingConfirm: '交易已廣播，等待鏈上確認...',
      chainSuccess: '鏈上轉帳成功！',
      chainPending: '等待後端確認到帳，餘額將在片刻後更新',
      chainError: '鏈上轉帳失敗，請重試',
      submitting: '正在提交預測...',
      fetchingConfig: '取得鏈上配置...',
      waitingSignBtn: '等待錢包簽名...',
      waitingConfirmBtn: '等待鏈上確認...',
      processingBtn: '處理中...',
    },
    settlement: {
      settled: '市場已結算',
      expired: '市場已截止',
      result: '結果：{{side}} 方獲勝',
      waiting: '等待結算中...',
      won: '獲勝',
      yesLabel: 'YES · 是',
      noLabel: 'NO · 否',
      condition: '市場條件',
      conditionDesc: '截止時價格{{type}} ${{price}}',
      priceBelow: '低於',
      priceEqual: '等於',
      priceAbove: '高於',
      endTime: '截止時間',
      settledToast: '市場已結算！結果：{{side}} 方獲勝',
      settledToastDesc: '訂單列表已自動更新，請查看最新盈虧。',
    },
    sort: {
      volume: '按交易量',
      endTime: '按截止時間',
      newest: '最新上線',
      liquidity: '按流動性',
    },
    filter: {
      status: '狀態',
      category: '分類',
      endTime: '截止時間',
    },
    markets: {
      badge: '大宗商品預測市場',
      subtitle: '參與大宗商品價格預測，固定截止時間，公平競猜',
      activeMarkets: '活躍市場',
      totalMarkets: '總市場',
      yesPercent: '是 {{n}}%',
      noPercent: '否 {{n}}%',
      active: '進行中',
      ended: '已結束',
    },
    card: {
      hot: '熱門',
      up: '漲',
      down: '跌',
      countdown: '距結算',
      participants: '參與人數',
      expired: '已截止',
      daysLater: '{{n}}天後',
      hoursLater: '{{n}}小時後',
      closed: '休市',
      unitDay: '天',
      unitHour: '小時',
      unitMin: '分',
      unitSec: '秒',
    },
  },

  // 持倉
  portfolio: {
    title: '我的持倉',
    totalValue: '持倉總值',
    unrealizedPnl: '未實現盈虧',
    realizedPnl: '已實現盈虧',
    positions: '當前持倉',
    history: '歷史訂單',
    noPositions: '暫無預測記錄',
    loginRequired: '請先登入後查看持倉',
    goToMarkets: '前往市場大廳參與預測',
    profit: '收益',
    loss: '損失',
    amount: '參與金額',
    claimSuccess: '獎勵領取成功！',
    claimFailed: '領取失敗，錯誤碼：{{code}}',
    activeLabel: '預測中',
    statusWon: '已勝',
    statusLost: '已負',
    statusActive: '預測中',
    settledLabel: '已結算',
    netProfit: '淨收益',
    accountBalance: '帳戶餘額',
    activeTab: '預測中',
    historyTab: '歷史記錄',
    columns: {
      market: '市場',
      side: '方向',
      amount: '金額',
      avgPrice: '均價',
      currentPrice: '當前價',
      pnl: '盈虧',
      action: '操作',
    },
  },

  // 錢包
  wallet: {
    title: '我的錢包',
    balance: '可用餘額',
    totalAssets: '總資產',
    deposit: '充值',
    withdraw: '提現',
    transfer: '轉帳',
    history: '交易記錄',
    totalBalance: '總資產',
    available: '可用餘額',
    frozen: '凍結中',
    totalDeposit: '累計充值',
    totalWithdraw: '累計提現',
    loginRequired: '請先登入後查看錢包',
    loginNow: '立即登入',
    refreshed: '資料已重新整理',
    txHistory: {
      all: '全部',
      deposit: '充值',
      withdraw: '提現',
      bet: '競猜',
    },
    depositModal: {
      title: '充值',
      network: '選擇網路',
      address: '充值地址',
      minAmount: '最小充值金額',
      tips: '充值注意事項',
      confirmed: '充值交易已確認，餘額將在 1-5 分鐘內到帳',
      warning: '請確保 MetaMask 已切換到 BSC 主網（BNB Smart Chain）。充值 USDT（BEP-20）將直接從您的錢包轉入平台，確認後自動到帳。',
      confirm: '確認充值',
      close: '關閉',
      betDeposit: '預測保證金',
      depositUsdt: '充值 USDT',
      noDeposits: '暫無充值記錄',
    },
    withdrawModal: {
      title: '提現 USDT',
      address: '提現地址',
      amount: '提現金額',
      amountLabel: '提現金額',
      available: '可用：',
      minHint: '最小 20 USDT',
      all: '全部',
      fee: '手續費',
      actualAmount: '實際到帳',
      confirm: '確認提現',
      invalidAmount: '請輸入有效的提現金額',
      exceedBalance: '提現金額不能超過可用餘額',
      submitted: '提現申請已提交，預計 24 小時內到帳',
      failed: '提現失敗，錯誤碼：{{code}}',
      error: '提現請求失敗',
      noWithdraws: '暫無提現記錄',
    },
    transactionType: {
      deposit: '充值',
      withdraw: '提現',
      win: '競猜獲獎',
      loss: '競猜虧損',
      fee: '手續費',
    },
    status: {
      completed: '已完成',
      pending: '處理中',
      failed: '失敗',
      reviewing: '審核中',
      approved: '已批准',
      done: '已完成',
      unknown: '未知',
    },
    withdrawStatus: {
      0: '審核中',
      1: '已批准',
      2: '已完成',
    },
    loadingDeposit: '載入中...',
    loadingWithdraw: '載入中...',
    depositUsdt: '充值 USDT',
    withdrawUsdt: '提現 USDT',
    depositAmount: '充值金額 (USDT)',
    receivingAddress: '收款地址',
    connectWalletFirst: '請先連接錢包',
    metamaskNotFound: '未偵測到 MetaMask，請安裝 MetaMask 外掛',
    chainConfigFailed: '取得鏈配置失敗',
    waitingSign: '等待 MetaMask 簽名...',
    waitingConfirm: '等待鏈上確認...',
    viewTx: '查看交易',
    depositConfirmed: '充值交易已確認，餘額將在 1-5 分鐘內到帳',
    depositBroadcast: '交易已廣播，充值將在確認後到帳',
    depositConfirmedMsg: '充值交易已確認，餘額將在 1-5 分鐘內到帳',
    depositWarning: '請確保 MetaMask 已切換到 BSC 主網（BNB Smart Chain）。充值 USDT（BEP-20）將直接從您的錢包轉入平台，確認後自動到帳。',
    userRejectedSign: '已取消：使用者拒絕了錢包簽名',
    tonWallet: 'TON 錢包',
    connectTonWallet: '連接 TON 錢包',
    tonDepositWarning: '請使用 TON 錢包發送 USDT Jetton，系統將自動識別並到帳。',
    depositFailed: '充值失敗',
    guidError: '無法獲取用戶 GUID，請重新登錄後再試',
    jettonWalletError: '無法獲取 Jetton Wallet 地址',
    jettonWalletFetchError: '獲取 TON Jetton Wallet 地址失敗，請稍後重試',
    confirmDeposit: '確認充值',
    minDepositError: '最小充值金額為 10 USDT',
    depositMinHint: '最小 {{min}} USDT',
    withdrawAmount: '提現金額',
    selectChain: '選擇提現鏈',
    withdrawAddress: '提現地址',
    withdrawAddressPlaceholder: '請輸入收款錢包地址（如 0x...）',
    withdrawAddressPlaceholderTon: 'UQ... 或 EQ... 格式的 TON 地址',
    withdrawAddressPlaceholderEvm: '0x... 格式的 EVM 地址',
    withdrawAddressRequired: '請輸入提現錢包地址',
    withdrawMinHint: '提现金額不能低於 {{min}} USDT',
    fee: '手續費',
    actualAmount: '實際到帳',
    confirmWithdraw: '確認提現',
    invalidWithdrawAmount: '請輸入有效的提現金額',
    insufficientBalance: '提現金額不能超過可用餘額',
    withdrawSubmitted: '提現申請已提交，預計 24 小時內到帳',
    withdrawFailed: '提現失敗，錯誤碼：{{code}}',
    withdrawRequestFailed: '提現請求失敗',
    noDeposits: '暫無充值記錄',
    noWithdrawals: '暫無提現記錄',
    statusReviewing: '審核中',
    statusTransfering: '轉帳中',
    statusApproved: '已審核',
    statusCompleted: '已完成',
    statusUnknown: '未知',
    dataRefreshed: '資料已重新整理',
    balanceUpdated: '餘額已更新',
  },

  // 排行榜
  leaderboard: {
    title: '收益排行榜',
    subtitle: '累計收益最高的預測者',
    listTitle: '收益排行榜',
    period: {
      daily: '今日',
      weekly: '本週',
      monthly: '本月',
      all: '總榜',
    },
    columns: {
      rank: '排名',
      user: '用戶',
      pnl: '盈虧',
      pnlPercent: '收益率',
      volume: '交易量',
      winRate: '勝率',
      markets: '參與市場',
      profit: '累計收益',
    },
    smartMoney: '聰明錢包',
    profitLabel: '累計收益',
    loading: '載入中...',
    noData: '暫無收益排行榜資料',
    champion: '冠軍',
    runnerUp: '亞軍',
    thirdPlace: '季軍',
    gold: '冠軍',
    silver: '亞軍',
    bronze: '季軍',
    me: '我',
    user: '用戶',
    totalProfit: '累計收益',
    empty: '暫無收益排行榜資料',
    myRank: '您當前排名第 {{rank}} 名 · 累計收益 +{{profit}}',
    notRanked: '您當前未上榜 · 繼續參與預測以提升排名',
  },

  // 個人中心
  profile: {
    title: '個人中心',
    editProfile: '編輯資料',
    settings: '帳戶設定',
    security: '安全設定',
    notifications: '通知設定',
    telegram: 'Telegram 綁定',
    language: '語言設定',
    theme: '主題設定',
    about: '關於我們',
    preferences: '偏好設定',
    loginRequired: '請先登入後查看個人中心',
    loginNow: '立即登入',
    logoutSuccess: '已成功登出',
    telegramBound: 'Telegram 已綁定',
    telegramNotBound: '未綁定',
    languageCurrent: '繁體中文',
    stats: {
      totalPnl: '總盈虧',
      winRate: '勝率',
      totalMarkets: '參與市場',
      totalVolume: '總交易量',
    },
    rewards: {
      title: '完善資訊得積分',
      completed: '{{n}}/{{total}} 已完成',
      pointsLabel: '已獲積分',
      tip: '積分可用於兌換手續費減免、代幣空投資格及專屬權益解鎖',
      bindEmail: '綁定信箱',
      bindPhone: '綁定手機號',
      bindTelegram: '綁定 Telegram',
      kyc: '完成身份認證',
      done: '已完成',
    },
    securityTip: {
      web3Tip: 'Web3 安全提示',
      web3TipDesc: '請妥善保管您的錢包私鑰和助記詞。AugurX 不會儲存您的私鑰，官方人員不會主動索取任何敏感資訊。',
    },
  },

  // 登入註冊
  auth: {
    login: {
      title: '歡迎回來',
      subtitle: '連接錢包即可開始預測',
      email: '信箱地址',
      password: '密碼',
      forgotPassword: '忘記密碼？',
      submit: '登入',
      noAccount: '還沒有帳戶？',
      register: '立即註冊',
      orContinueWith: '或使用信箱登入',
      connectWallet: '連接錢包',
      walletSubtitle: '無需註冊，連接錢包即可匿名使用',
      metamask: 'MetaMask',
      walletconnect: 'WalletConnect',
      okx: 'OKX Wallet',
      connectAndPredict: '連接並開始預測',
      connectDesc: '選擇您的登入方式，無需註冊，即連即用',
      connectWalletLabel: '連接錢包',
      or: '或',
      terms: '服務條款',
      privacy: '隱私政策',
      agreePrefix: '連接即代表您同意',
      agreeMid: '與',
      termsComingSoon: '服務條款即將上線',
      privacyComingSoon: '隱私政策即將上線',
      telegramComingSoon: 'Telegram 登入正在對接中，敬請期待',
      telegramBotOnly: '請透過 Telegram Bot 開啟此應用以使用 Telegram 登入',
      telegramDesc: '透過 Telegram Bot 授權登入',
      recommended: '推薦',
      walletConnecting: '連接錢包中...',
      walletSigning: '請在錢包中簽名...',
      walletLoggingIn: '驗證登入中...',
      walletConnecting2: '連接中...',
      connectSuccess: '錢包連接成功！歡迎使用 AugurX',
      connectFailed: '錢包連接失敗，請重試',
      connectError: '連接失敗：{{msg}}',
      brandTitle: '預測大宗商品\n掌握市場先機',
      brandDesc: '連接錢包或 Telegram，無需註冊，匿名參與全球預測市場',
      feature1: '高頻市場：5分鐘極速競猜',
      feature2: '貴金屬、能源、化學品全覆蓋',
      feature3: '全球排行榜，聰明錢包追蹤',
      walletDesc: {
        metamask: '最流行的以太坊錢包',
        walletconnect: '支援 300+ 行動端錢包',
        okx: 'OKX 官方錢包',
      },
    },
    register: {
      title: '建立帳戶',
      subtitle: '加入 AugurX 預測市場',
      username: '用戶名',
      email: '信箱地址',
      password: '密碼',
      confirmPassword: '確認密碼',
      inviteCode: '邀請碼（選填）',
      agreeTerms: '我已閱讀並同意',
      terms: '服務條款',
      and: '和',
      privacy: '隱私政策',
      submit: '註冊',
      hasAccount: '已有帳戶？',
      login: '立即登入',
    },
    forgotPassword: {
      title: '找回密碼',
      subtitle: '輸入您的信箱，我們將發送重設連結',
      email: '信箱地址',
      submit: '發送重設郵件',
      backToLogin: '返回登入',
    },
  },

  // Telegram
  telegram: {
    title: '綁定 Telegram',
    subtitle: '綁定 Telegram 帳號，隨時隨地接收市場提醒',
    features: {
      notifications: '即時市場提醒',
      trading: 'Bot 快捷競猜',
      results: '結算通知',
    },
    bindButton: '立即綁定',
    bound: '已綁定',
    unbind: '解除綁定',
    botName: '@AugurXBot',
    steps: {
      step1: '點擊下方按鈕，跳轉到 Telegram',
      step2: '向 Bot 發送 /start 指令',
      step3: '複製驗證碼並在此處輸入',
    },
    verifyCode: '驗證碼',
    verify: '驗證',
  },

  // 頁尾
  footer: {
    copyright: '© 2025 AugurX. 專業大宗商品與加密貨幣預測市場。',
    terms: '服務條款',
    privacy: '隱私政策',
    help: '幫助中心',
  },
  // K 線圖
  chart: {
    loading: '載入 K 線資料...',
    noData: '暫無 K 線資料',
    noDataDesc: '資料同步中，請稍後重新整理頁面',
    myBet: '我的押注',
  },
  // 404
  notFound: {
    title: '頁面未找到',
    desc: '您訪問的頁面不存在或已被移除',
    backHome: '返回首頁',
  },

  // 伺服器狀態守衛
  serverStatus: {
    connectionFailed: '連接伺服器失敗',
    connectionFailedDesc: '無法連接到伺服器，請檢查您的網路連線，或稍後再試。',
    maintenance: '伺服器維護中',
    maintenanceDesc: '系統正在進行維護升級，預計很快恢復。\n感謝您的耐心等待。',
    retry: '重新嘗試',
    retrying: '正在重新連接...',
    autoCheck: '系統將每 10 秒自動偵測服務狀態',
    maintenanceMode: '維護模式',
    unreachable: '服務不可達',
  },
  // 市場卡片角標
  marketBadge: {
    participating: '參與中',
  },
  // Token 過期
  tokenExpired: {
    title: '登入已過期',
    message: '您的登入狀態已失效，請重新登入',
    action: '重新登入',
  },

  // 邀請
  invite: {
    navLabel: '邀請',
    title: '邀請好友',
    subtitle: '邀請好友加入 AugurX，一起賺取積分',
    yourCode: '您的邀請碼',
    copyCode: '複製邀請碼',
    copyLink: '複製邀請連結',
    shareOnTelegram: '分享至 Telegram',
    codeCopied: '邀請碼已複製！',
    linkCopied: '邀請連結已複製！',
    stats: {
      invited: '已邀請好友',
      pointsEarned: '邀請獲得積分',
      totalPoints: '我的總積分',
    },
    howItWorks: '如何運作',
    step1Title: '分享您的連結',
    step1Desc: '透過 Telegram 或任何管道，將您的專屬邀請連結或邀請碼分享給好友。',
    step2Title: '好友加入',
    step2Desc: '好友透過您的邀請連結註冊，並開始在 AugurX 進行競猜。',
    step3Title: '共同獲利',
    step3Desc: '好友每次競猜，您將永久獲得其積分的 10% 作為邀請獎勵。',
    rewardRule: '您邀請的好友每次競猜成功，您將獲得其積分的 10% 作為獎勵。',
    history: '邀請獎勵記錄',
    historyEmpty: '暫無邀請獎勵記錄，邀請好友開始獲取積分吧！',
    historyAccount: '好友',
    historyPoints: '獲得積分',
    historyTime: '時間',
    loginRequired: '請先登入以查看邀請資訊',
    loginNow: '立即登入',
    loadMore: '載入更多',
  },
  // 關於我們
  about: {
    title: '關於 AugurX',
    subtitle: '大宗商品與加密貨幣去中心化預測市場',
    hero: {
      headline: '預測・獲利・贏取',
      desc: 'AugurX 是基於 TON 和 EVM 鏈的高頻預測市場平台，專注於大宗商品和加密資產。預測市場走勢，賺取豐厚獎勵。',
    },
    features: {
      title: '為何選擇 AugurX？',
      highFreq: {
        title: '高頻競猜',
        desc: '每 5 分鐘一輪，涵蓋黃金、石油、BTC、ETH 等熱門資產，快速刺激，獎勵豐厚。',
      },
      multiChain: {
        title: '多鏈支援',
        desc: '支援 TON 錢包（Telegram）和 EVM 錢包（MetaMask、OKX、WalletConnect）無縫接入。',
      },
      transparent: {
        title: '透明公平',
        desc: '所有競猜和結算均記錄在鏈上，無人為干預，無隱藏費用。',
      },
      points: {
        title: '積分與獎勵',
        desc: '每次競猜均可獲得積分，可兌換手續費折扣、代幣空投及專屬福利。',
      },
    },
    howToPlay: {
      title: '如何參與',
      step1: '連接您的 TON 或 EVM 錢包',
      step2: '充值 USDT 至您的帳戶',
      step3: '選擇市場，預測漲跌',
      step4: '勝出後領取獎勵',
    },
    points: {
      title: '積分系統',
      desc: '透過競猜和邀請獲取積分，積分可解鎖專屬福利。',
      predict: '每競猜 1 USDT 獲得 1 積分',
      refer: '邀請好友競猜，獲得其積分的 10%',
      bindEmail: '綁定信箱獲得 +50 積分',
      bindPhone: '綁定手機獲得 +30 積分',
      bindTelegram: '綁定 Telegram 獲得 +80 積分',
      redeem: '積分可兌換手續費折扣、代幣空投及專屬福利',
    },
    community: {
      title: '加入我們的社群',
      telegram: 'Telegram 機器人',
      twitter: '關注 X（Twitter）',
    },
    contact: {
      title: '聯絡我們',
      desc: '有任何問題或建議？請透過官方管道聯絡我們。',
    },
  },
  // 錯誤資訊
  errors: {
    required: '此欄位為必填項',
    invalidEmail: '請輸入有效的信箱地址',
    passwordTooShort: '密碼至少需要 8 個字元',
    passwordMismatch: '兩次輸入的密碼不一致',
    networkError: '網路連線失敗，請稍後重試',
    unauthorized: '請先登入',
    notFound: '頁面不存在',
  },
};

export default zh;
export type TranslationKeys = typeof zh;
